var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 15.1667C4.3167 15.1667 1.33203 12.182 1.33203 8.50004C1.33203 4.81804 4.3167 1.83337 7.9987 1.83337C11.6807 1.83337 14.6654 4.81804 14.6654 8.50004C14.6654 12.182 11.6807 15.1667 7.9987 15.1667ZM7.33203 7.83337V11.8334H8.66536V7.83337H7.33203ZM7.33203 5.16671V6.50004H8.66536V5.16671H7.33203Z",
    fill: "#929BA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.aabd5b8ad64f52f8decb4cea9f94daab.svg";
export { ForwardRef as ReactComponent };